module.exports = __webpack_public_path__ + "static/media/fasttrack2.48e369db.jpeg";